import { useEffect, useState } from 'react'
import { HttpSistema } from '../api/httpSistema'
import { FirmasConLabels } from '../types/firma'

// const QUERY_STATUS = {
//     IDLE: 'idle',
//     LOADING: 'loading',
//     SUCCESS: 'success',
//     ERROR: 'error'
// } as const

// type QueryStatus = (typeof QUERY_STATUS)[keyof typeof QUERY_STATUS]

type StateObject<TEntity> =
    | {
          status: 'idle'
      }
    | {
          status: 'loading'
      }
    | {
          status: 'success'
          entity: TEntity
      }
    | {
          status: 'error'
          error: string
      }

export const useFirmas = (codSistema: number, idOperacion: number) => {
    const [state, setState] = useState<StateObject<FirmasConLabels>>({ status: 'idle' })

    const fetch = () => {
        setState({ status: 'loading' })

        HttpSistema.getFirmas(codSistema, idOperacion)
            .then(value => {
                setState({
                    status: 'success',
                    entity: value
                })
            })
            .catch(err => {
                setState({
                    status: 'error',
                    error: err
                })
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [idOperacion])

    if (state.status === 'success') {
        return { status: state.status, firmas: state.entity, refetch }
    }

    return { status: state.status, refetch }
}
